module.exports = __webpack_public_path__ + "img/farzana-christopher-43.2ffab36e.jpg";